import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        // const expectedRole = route.data.expectedRole;
        if (currentUser) {
            return true;
        }

        // not logged in so redirect to login page with the return url
       // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
       alert("Session is expired please login")
       this.authenticationService.logout();
        return false;
    }
}